import { render, staticRenderFns } from "./SelectTerminals.vue?vue&type=template&id=2c9c7674&"
import script from "./SelectTerminals.vue?vue&type=script&lang=js&"
export * from "./SelectTerminals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports